import React from 'react';

import Button from './../Button';
import FormGroup from './../FormGroup';
import ConfirmButtons from './ConfirmButtons';

import Translator from './../../requests/apa/Translator';
import UtilsPagos from "../../utils/payway/UtilsPagos";

const Hubgate = ({ labels, paywayChange, setCurrentKey, currentValues, onAccept, onCancel, onFieldError, errors, workflowInfo, gateway, validateForm }) => {

  const inputDocument = "document";
  const inputMovil = gateway === "hubfijogate" ? "numberField" : "movil";
  

  const hasDocument = UtilsPagos.hasDocument(gateway);

  return (
    <div>
      <div className='gatewayTitle'>
        <span>{workflowInfo.gatewaytext}</span>  
        <Button className='button positionButtonTop' text={Translator.get('btn_change_payment', 'Cambiar')} onClick={paywayChange}/>
      </div>
      <div className='gatewayForm positionFormTop'>
        {(hasDocument) &&
          <div className='row'>
            <FormGroup
              id={inputDocument}
              value={currentValues[inputDocument]}
              error={errors[inputDocument]}
              message={errors[inputDocument] ? errors[inputDocument] : ''}
              placeholder={labels.placeHolderDocument}
              onFocused={() => {
                setCurrentKey(inputDocument);
              }} />
          </div>
        }
        <div className='row'>
          <FormGroup
            id={inputMovil}
            value={currentValues[inputMovil]}
            error={errors[inputMovil]}
            message={errors[inputMovil] ? errors[inputMovil] : ''}
            placeholder={labels.placeHolderMovil}
            onFocused={() => {
              setCurrentKey(inputMovil);
            }} />
        </div>
      </div>
      <ConfirmButtons
        onCancel={() => {
          onCancel(this);
        }}
        onAccept={() => {
          if (validateForm(currentValues, errors, hasDocument ? ['pinCode'] : ['pinCode', inputDocument])) {
            onAccept(gateway);
          }
        }}
      />
    </div>
  )
}
export default Hubgate



// WEBPACK FOOTER //
// ./src/components/Payment/Hubgate.jsx